import React from "react";
import { Grid,CircularProgress } from "@mui/material";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import DialogForm from "@/components/modal/DialogForm";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import FormikDatePicker from "@/components/forms/FormikDatePicker";
import { StyledButton } from "@/components";
import FormikRadioGroup from "@/components/forms/FormikRadioGroup";
import mapOptions from "@/utils/mappers/mapOptions";
import dayjs from "dayjs";
import FormikMonthYearPicker from "@/components/forms/FormikMonthYearPicker";
import { useProcessAttendanceMutation } from "@/api/services/attendanceManagement/muster/Muster";
import { toast } from "@/components/toastify";
import FormikMultipleSelectChip from "@/components/forms/FormikMultipleSelectChip";

const ProcessAttendance = ({ open, setOpen, fetchActiveEmployee }) => {

  const [processAttendance] = useProcessAttendanceMutation();

  // const validationSchema = Yup.object({
  //   SelectEmployee: Yup.string().required("Please select an employee"),
  //   SelectMonth: Yup.date().required("Please select a month and year"),
  // });

  const validationSchema = Yup.object({
    SelectMonth: Yup.string().required("Please select a month and year"),
    // SelectEmployee: Yup.string().when("Employee", {
    //   is: "Selected Employees",
    //   then: Yup.string().required("Please select an employee"),
    // }),
  });


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const { SelectMonth, Employee, SelectEmployee } = values;
      // Prepare API parameters
      const params = {
        monthYear: dayjs(SelectMonth, ["MM-YYYY", "YYYY-MM", "YYYY-MM-DD"]).format("MM-YYYY"),
        isAll: Employee === "All Employees",
      };
      // If Selected Employees, add empId parameter(s)
      if (Employee === "Selected Employees" && SelectEmployee) {
        params.empId = SelectEmployee;
      }
      await processAttendance({ params }).unwrap();
      toast("success", "Attendance processed successfully!");
      resetForm();
      setOpen(false);

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DialogForm
      setOpen={setOpen}
      width={"sm"}
      height="auto"
      title={"Process Attendance"}
      open={open}
    >
      <Formik
        initialValues={{
          SelectMonth: "",
          Employee: "All Employees",
          SelectEmployee: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values, resetForm,isSubmitting }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormikMonthYearPicker
                  name="SelectMonth"
                  label="Process Month"
                  pickerType="month"
                  placeholder="Select Month & Year"
                  required
                  value={values.SelectMonth ? dayjs(values.SelectMonth, "MM-YYYY").format("MMMM YYYY") : ""}
                  onChange={(formattedDate) => {
                    const formatted = dayjs(formattedDate).format("MM-YYYY");
                    setFieldValue("SelectMonth", formatted);
                  }}
                // value={values.SelectMonth ? dayjs(values.SelectMonth, "MM-YYYY").format("MMMM YYYY") : ""}
                // onChange={(formattedDate) => {
                //   const formatted = dayjs(formattedDate).format("MM-YYYY");
                //   setFieldValue("SelectMonth", formatted);
                // }}
                />
              </Grid>
            </Grid>
            <FormikRadioGroup
              name="Employee"
              label="Employee"
              options={[
                { value: "All Employees", label: "All Employees" },
                { value: "Selected Employees", label: "Selected Employees" },
              ]}
              onChange={(event) => setFieldValue("Employee", event.target.value)}
              required
            />
            {/* Conditionally render the employee selection grid */}
            {values.Employee === "Selected Employees" && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikMultipleSelectChip
                    name="SelectEmployee"
                    label="Select Employee"
                    required
                    placeholder="Select Employee"
                    search={true}
                    options={mapOptions(fetchActiveEmployee || [])}
                    rows={1.5}
                  />
                </Grid>
              </Grid>
            )}
            <Grid container justifyContent="flex-end" spacing={2} mt={1}>
              <Grid item xs={12} sm={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <StyledButton
                  label={"Cancel"}
                  type="button"
                  variant="outlined"
                  onClick={() => { setOpen(false); resetForm(); }}
                  sx={{ mr: 1 }}
                />
                <StyledButton
                  label={isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                  type="submit"
                  variant="contained"
                />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </DialogForm>
  );
};

export default ProcessAttendance;
